module.exports = __webpack_public_path__ + "img/upload-img-bg3.662b55ac.png";